// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2auRC","content":"RecentSearches_content__1bM5n"};